export const adhpQuery = (code: string) => `
{
  ADHP(code: "${code}") {
    id
    createdAt
    updatedAt
    code
    name
    type
    city
    uf
    geolocation {
      lat
      lng
      alt
    }
    rotaerHTML {
      createdAt
      updatedAt
      html
    }
    rotaer {
      createdAt
      updatedAt
      typeUtil
      org {
        name
        type
        military
      }
      distance
      utc
      typeOpr
      altM
      altFt
      fir
      jur
      lights {
        code
        desc
        compl
      }
      runways {
        type
        ident
        surface
        surfaceC
        length
        width
        lights {
          code
          desc
          compl
        }
        thr {
          ident
          lights {
            code
            desc
            compl
          }
        }
      }
      communications {
        type
        callsign
        freqs {
          freq
          compl
        }
      }
      rdonav {
        type
        cat
        thr
        ident
        freq
        geolocation {
          lat
          lng
          alt
        }
        org {
          name
          type
          military
        }
      }
      rffs {
        cat
      }
      services {
        ser
      }
      cmb {
        title
        code
      }
      met {
        contact
        type
        selfservice
        org {
          name
          type
          military
        }
      }
      rmks {
        cod
        text
      }
      compls {
        cod
        text
      }
      timesheets {
        n
        days
        begin
        end
        hol
      }
    }
    infotemp {
      id
      createdAt
      updatedAt
      status
      number
      n
      rmk
      startdate
      enddate
      fir
      aipcod
      section
      dt
      idRevoga
    }
    aipsup {
      id
      createdAt
      updatedAt
      status
      n
      serie
      type
      dt
      title
      text
      dur
      ref
    }
    notam {
      id
      createdAt
      updatedAt
      cod
      status
      cat
      dist
      tp
      dt
      n
      number
      b
      c
      d
      text
      f
      g
      nof
      s
      origin
      fir
      traffic
      lower
      upper
      state
      purpose
      scope
    }
    meteorology {
      createdAt
      updatedAt
      metar
      taf
    }
    daytime {
      createdAt
      updatedAt
      date
      sunrise
      sunset
      weekDay
    }
    charts {
      createdAt
      updatedAt
      id
      species
      type
      typeDesc
      name
      dt
      originalLink
      localLink
      amdt
      use
    }
    metarHistory
  }
}
`
